import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import './ConfirmDialog.css';

const ConfirmDialog = ({ isOpen, title, message, onConfirm, onCancel, confirmText = 'Remove', cancelText = 'Cancel', zIndex }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  const overlayStyle = zIndex ? { zIndex } : {};

  return (
    <div className="confirm-dialog-overlay" onClick={handleOverlayClick} style={overlayStyle}>
      <div className="confirm-dialog">
        <div className="confirm-dialog-header">
          <AlertTriangle className="confirm-icon" size={24} />
          <h3>{title || 'Confirm Action'}</h3>
          <button className="confirm-close-btn" onClick={onCancel}>
            <X size={20} />
          </button>
        </div>
        
        <div className="confirm-dialog-body">
          <p>{message}</p>
        </div>
        
        <div className="confirm-dialog-footer">
          <button className="confirm-btn-cancel" onClick={onCancel}>
            {cancelText}
          </button>
          <button className="confirm-btn-confirm" onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;